import React, { useState } from "react";

import Col from "react-bootstrap/Col";
import { Row } from "react-bootstrap";
import { IoCheckmarkDone, IoChevronDown, IoChevronUp } from "react-icons/io5";

import PlanDay from "./PlanDay";
import { PALETTE } from "../../common/ThemeConstants";

export default function PlanWeek({ week, n_week, isLocked }) {
  const nWorkouts = week.planDays.length;
  const nWorkoutsCompleted = (week.planDays.filter(d => d.done)).length
  const isWeekCompleted = nWorkoutsCompleted === nWorkouts;
  const Icon = isWeekCompleted ? IoCheckmarkDone : IoCheckmarkDone;
  const color = PALETTE.DARK;

  // Add state for expanded/collapsed content - default to expanded if not all workouts completed
  const [expanded, setExpanded] = useState(!isWeekCompleted);

  // Toggle function for expand/collapse
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  // Determine which icon to show based on expanded state
  const ExpandIcon = expanded ? IoChevronUp : IoChevronDown;
  return (
    <div
      id={n_week}
      className="rounded-sm py-2 px-2 my-1 shadow-sm"
      style={{
        // border: "1px solid " + PALETTE.KINDALIGHTGRAY,
        opacity: isWeekCompleted ? 0.5 : 1,
        background: PALETTE.WHITE,
      }}
    >
      <Row className="py-1">
        <Col>
          <p style={{ marginBottom: 0, color: color, fontWeight: "bold" }}>
            Settimana {week.position + 1}
          </p>
        </Col>
        <Col className="align-self-center text-end" style={{ color: color }}>
          <p style={{ marginBottom: 0, fontSize: 14, color: color }}>
            {isWeekCompleted && <Icon size={20} style={{ marginBottom: 4, marginRight: 4 }} />}
            {nWorkoutsCompleted}/{nWorkouts} completati
          </p>
        </Col>
        {/* New column with expand/collapse icon */}
        <Col xs="auto" className="align-self-end" style={{ cursor: "pointer" }} onClick={toggleExpand}>
          <ExpandIcon size={20} style={{ color: color }} />
        </Col>
      </Row>
      {/* Conditionally render content based on expanded state */}
      {expanded && (
        <div
          className="d-flex flex-nowrap overflow-auto py-2 px-1"
          style={{
            maxWidth: "fit-content",
            scrollbarWidth: "none",
          }}
        >
          {week.planDays.map((planDay, idx) => (
            <Col
              key={planDay.id}
              className="my-1 mx-1"
            >
              <PlanDay planDay={planDay} n_week={n_week} n_day={idx} width={240} isLocked={isLocked} />
            </Col>
          ))}
        </div>
      )}
    </div>
  );
}
